/**
 * Goods Sales Store
 *
 * @author minkyoung.park@emcast.com
*/
// states
const state = {
    userAuthDetail: null,
}

// getters
const getters = {}


// actions
const actions = {
    SET_USER_AUTH_DETAIL({ commit } , value) {
        commit('GET_USER_AUTH_DETAIL', value)
    }

}


// mutations
const mutations = {
    GET_USER_AUTH_DETAIL(state, value) {
        state.userAuthDetail = value
    },
    
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}